/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */

import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import parse from 'html-react-parser';
import XLSX from 'xlsx';
import { BroadbandLabel } from '@plans/tiles';
import { Button, TextLink, TextLinkCaret } from '@vds/buttons';
import { TitleLockup } from '@vds/type-lockups';
import xss from 'xss';

import ReqInput from '../../common/ReqInput'
import { FWAContainer } from '../../common/FWAContainer';
import { Row, Col } from '../../common/Grid';

import { getBroadBandFacts } from '../../common/PlansHelperFile';

import { apiUrls } from '../../../constants/apiUrl';
import { LanguageLink } from '../AddressSearch/spanishLink';
import {
  isDesktop,
  isMVA,
  isHomeInternetBroadBandFlow,
  getSession,
  checkStandAloneFccPage,
  getCookie,
  isMobile,
  getFCCFlowName,
  fccConstantValues,
  setSession,
  setCookie,
  isTablet,
  isFCCInternalPage,
} from '../../common/Helpers';
import Notification from '../../common/Notification/redesign/index';
import {
  getBroadBandHeader,
  getPayloadProspect,
  setCookieDetails,
  showAddress,
  showSurcharges,
  getSelectedAddress,
  restoreSessionDetails,
  enableBroadBandFacts,
  setCookieFromURL,
  getFCCCookies,
} from '../AddressSearch/constant';
import AddressSearchComponent from '../AddressSearch/addressSearch';
import CommonModal from '../../common/Modal';
import { ExternalHeaderAndFooterIntegration } from '../AddressSearch/headerFooter';
import logger from '../../common/ErrorBoundary/logger_new';
import { CarouselComponent } from './carousel';
import { eventDispatcher } from '../../common/Tagging';
import { isValidLabelsDate } from '../../common/validation';
import { store } from '../../../configureStore';

export default class BroadBandFacts extends Container {
  constructor(props) {
    super(props);
    enableBroadBandFacts();
    const { site, category } = getFCCCookies();
    if (!site && !category) {
      setCookieFromURL();
    }
    if (getSession('sesExp') === 'Y' && getCookie('site') === 'InternalFlow' && getSession('fcc') === 'false') {
      window.location.href = apiUrls().redirectAddressSearch;
    }
    if ((!checkStandAloneFccPage() && getSession('fcc') === 'true') || getCookie('fcc') === true || getCookie('fcc') === 'true') {
      setCookieDetails('', '', '');
      setSession('SELECTED_ADDRESS', '');
    } else {
      setCookie('fcc', false);
      setSession('fcc', false);
    }
    ExternalHeaderAndFooterIntegration();
    this.state = {
      streetAddress: getSelectedAddress()?.entireStreetAddress || '',
      clickedSpanishLink: false,
      disableSaveButon: false,
    };
  }

  onClickOnLanguageTranslation = () => {
    this.setState({ clickedSpanishLink: true });
    restoreSessionDetails();
  };

  onChangeStreetAddress = (value) => {
    this.setState({ streetAddress: value });
  };

  apiIntegration = () => {    
    const { CBandPlansAPI, getFCCDetails, updateParsedAddress, getFCCProspectPlans } = this.props;
    if (isHomeInternetBroadBandFlow()) {
      if (JSON.parse(getSession('LQResponse'))) {
        CBandPlansAPI();
      } else {
        logger({
          json: true,
          eventType: 'FeInfo',
          message: 'LQResponse is not available in Session',
          note: `Session Empty on BroadBandFacts Page`,
          messageType: 'INFO',
        });
        window.location.href = apiUrls().redirect5Ghome;
      }
    } else {
      const addressSearch = getSelectedAddress();
      updateParsedAddress(addressSearch);
      const { flowName, site } = getFCCFlowName();
      if (flowName === fccConstantValues?.flowName?.Prepaid && site === fccConstantValues?.learnPageFlow) {
        const { deviceId, skuId } = getPayloadProspect();
        const data = {
          mtn: 'newLine1',
          deviceId,
          addressDetails: {
            addressLine1: addressSearch?.dispstr,
            city: addressSearch?.muni,
            state: addressSearch?.state,
            zipCode: addressSearch?.zip,
          },
          flowType: 'standalone',
          skuId,
        };
        if(isFCCInternalPage()){
          data.date = this.props?.selectedDate;
        }
        getFCCProspectPlans(data);
      } else {
        isFCCInternalPage() ? getFCCDetails(this.props?.selectedDate) : getFCCDetails();      
      }
    }
  };

  sendDataPassiveLQS = () => {
    // tagging for passiveLQA in FCC
    let detaileligble;
    let prodeligble;
    let deviceinfo;
    const FlowType = getSession('FlowType');
    const LQResponseData = JSON.parse(getSession('LQResponse'));
    const addressDetails = LQResponseData?.output;
    const { zipCode } = addressDetails || '';

    if (FlowType && FlowType === 'LTE') {
      detaileligble = 'lte eligible';
      prodeligble = 'lte';
    } else if (FlowType && FlowType === '5G') {
      if (getSession('isCBandQual') === 'Y') {
        detaileligble = '5G eligible -cband';
        prodeligble = '5G -cband';
      } else {
        detaileligble = '5G eligible -mmWave';
        prodeligble = '5G -mmWave';
      }
    } else {
      detaileligble = 'noteligible';
      prodeligble = '';
    }
    if (isMobile()) {
      deviceinfo = 'mobile';
    } else if (isTablet()) {
      deviceinfo = 'eordering tablet';
    } else {
      deviceinfo = 'eordering';
    }

    const APIName = 'sendData';
    const dataObject = {
      name: 'passive lq',
      data: {
        page: {
          flow: 'lq widget',
          subFlow: 'passive lq - fcc',
          zip: zipCode,
          LQZip: zipCode,
          // throttle: throttleValue,
          channel: 'Ordering',
          detail: `plq result -${detaileligble}`,
          // channelSession: channelSessionID,
          applicationName: deviceinfo,
        },
        user: {
          authStatus: 'anonymous',
          accountType: 'new customer',
          // session,
          productsQualified: prodeligble,
          zip: zipCode,
        },
        event: {
          value: 'event334',
        },
        target: {
          engagement: {
            intent: 'Ordering',
          },
        },
      },
    };
    eventDispatcher(APIName, dataObject);
  };

  componentDidMount() {
    if (isHomeInternetBroadBandFlow()) {
      this.sendDataPassiveLQS();
    }
    this.props.invokeTaggingAPI();
    document.title = 'BroadBandFacts';
    const { apiIntegration } = this;
    apiIntegration();
    this.setState({ fccJsonvalue: false });
  }

  getVDSStructure = (taxJson, listJson) => {
    if (listJson?.plans?.length > 0 && taxJson?.planTaxData?.length > 0) {
      const listJsonCopy = JSON.parse(JSON.stringify(listJson));
      listJsonCopy?.plans.map((item) => {
        taxJson?.planTaxData.map((taxItem) => {
          if (item?.planCode === taxItem?.planId || item?.nafSpoId === taxItem?.planId) {
            let additionalCharges = item?.sections?.filter((item1) => item1.id === 'additionalCharges');
            let additionalChargesData = additionalCharges?.[0]?.data;
            const additionalChargesCopy = [];
            additionalChargesCopy.push({
              label: 'Provider Monthly Fees',
              level: 'l1',
            });
            taxItem?.taxDetails?.map((detailedItem) => {
              if (detailedItem?.taxSurchargeInd === 'S') {
                additionalChargesCopy.push({
                  label: detailedItem?.taxDescription,
                  value: `$${detailedItem?.taxAmount}`,
                  level: 'l2',
                });
              }
            });
            additionalChargesData = [...additionalChargesCopy, ...additionalChargesData];
            // eslint-disable-next-line no-param-reassign
            additionalCharges = [
              {
                ...additionalCharges?.[0],
                data: additionalChargesData,
              },
            ];
            const sections = item?.sections?.filter((item2) => item2.id !== 'additionalCharges');
            // eslint-disable-next-line no-param-reassign
            item.sections = [...sections, ...additionalCharges];
          }
        });
      });
      const args = {
        broadbandFacts: getBroadBandFacts([], listJsonCopy, getBroadBandHeader(), '', 'external'),
      };
      this.props.updateTaxDetails(args);
    }
  };

  componentDidUpdate(nextProps) {
    if(isFCCInternalPage()){
      if(nextProps?.selectedDate !== this.props?.selectedDate){
        this.apiIntegration()
      }
    }
    if (isHomeInternetBroadBandFlow()) {
      if (nextProps?.planDetails !== this.props?.planDetails) {
        this.props.fccLabelContentActions(this.props?.selectedDate);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isHomeInternetBroadBandFlow()) {
      if (nextProps?.fccContentValue?.plans !== this.props?.fccContentValue?.plans) {
        this.setState({ fccJsonvalue: false });
        const sortedPlanIds = Object.keys(this.props?.planDetails || {}).filter((planId) => this.props.planDetails[planId]);
        const args = {
          broadbandFacts: getBroadBandFacts(sortedPlanIds, nextProps?.fccContentValue, 'Home Internet plans-broadband fact labels', '', 'internal'),
        };
        this.props.updateTaxDetails(args);
      }
    } else if (checkStandAloneFccPage()) {
      if (nextProps?.fccProspectLabel?.ProspectDetailList !== this.props?.fccProspectLabel?.ProspectDetailList) {
        const args = {
          broadbandFacts: getBroadBandFacts(
            [],
            nextProps?.fccProspectLabel?.ProspectDetailList?.data?.fccDevicePlans,
            getBroadBandHeader(),
            '',
            'external',
          ),
        };
        this.props.updateTaxDetails(args);
      }

      if (nextProps?.taxDetails !== this.props?.taxDetails) {
        this.getVDSStructure(nextProps?.taxDetails, this.props?.fccLabel?.detailList);
      }

      if (nextProps?.fccLabel?.detailList !== this.props?.fccLabel?.detailList) {
        const { makeNewBrowsingCall } = this.props;
        const planIdArray = [];
        const nafSpoIdsArray = [];
        nextProps?.fccLabel?.detailList.plans &&
          nextProps?.fccLabel?.detailList.plans.map((item) => {
            if (item?.planCode !== '28348' && !item?.nafSpoId) {
              planIdArray.push(item.planCode);
            } else if (item?.nafSpoId) {
              nafSpoIdsArray.push(item.nafSpoId);
            }
          });
        const addressSearch = getSelectedAddress();
        if (showSurcharges()) {
          if (planIdArray?.length !== 0 && addressSearch?.dispstr && addressSearch?.zip) {
            const surchargeData = {
              planIds: planIdArray,
              nafSpoIds: nafSpoIdsArray,
              address: {
                addressLine1: addressSearch?.dispstr,
                city: addressSearch?.muni,
                state: addressSearch?.state,
                zipCode: addressSearch?.zip,
              },
              planInfoRequired: true,
              isMaxTier: true,
              isAutoPayTierScheme: false,
            };
            if(isFCCInternalPage()){
              surchargeData.taxDate = this.props?.selectedDate;
            }            
            makeNewBrowsingCall(surchargeData);
          }
        } else {
          const args = {
            broadbandFacts: getBroadBandFacts([], nextProps?.fccLabel?.detailList, getBroadBandHeader(), '', 'external'),
          };
          this.props.updateTaxDetails(args);
        }
      }
    }
  }

  onClickingLink = (linkUrl) => {
    const bridgeAPIMsg = {
      actionType: 'openURL',
      pageType: 'openBrowser',
      browserUrl: linkUrl,
      openInWebview: true,
    };
    try {
      const bridgeAPIPostJson = JSON.stringify(bridgeAPIMsg);
      if (window?.webkit?.messageHandlers?.mfAppInterface?.postMessage) {
        window.webkit.messageHandlers.mfAppInterface.postMessage(bridgeAPIPostJson);
      }
      if (window?.mfAppInterface?.postMessage) {
        window.mfAppInterface.postMessage(bridgeAPIPostJson);
      }
    } catch (err) {
      console.log(err);
    }
  };

  getDiscountsAndBundles = (data) => {
    let value = '';
    const links = data?.discountsAndBundles?.descriptionLinks;
    links?.map((item) => {
      if (item?.linkKey === 'Discounts & Bundles') {
        value = item?.linkVal;
      }
    });
    return value;
  };

  getSurchargeDetails = (data, index) => {
    let taxvalue = '';
    for (let i = index + 1; i < data?.length; i++) {
      if (data[i]?.level === 'l2') {
        taxvalue = `${taxvalue}\n-${data[i]?.label} : ${data[i]?.value}`;
      } else {
        break;
      }
    }
    return taxvalue;
  };

  getTaxAndFeeDetails = (data, key) => {
    let taxvalue = '';
    data?.map((item, index) => {
      if (item?.label.toLowerCase().includes(key.toLowerCase())) {
        if (item.label.toLowerCase().includes('one-time fees')) {
          taxvalue = this.getSurchargeDetails(data, index);
        } else if (item.label.toLowerCase().includes('provider monthly')) {
          taxvalue = this.getSurchargeDetails(data, index);
        } else if (item?.value) {
          taxvalue = `${item.value}`;
        }
      }
    });
    return taxvalue;
  };

  getSpeedProvided = (data) => {
    let speedValue = '';
    if (Array.isArray(data)) {
      const speedsProvided = data.filter((value, index) => index % 2 === 0);
      speedsProvided.forEach((item) => {
        speedValue = `${speedValue}\n${item}`;
      });
    } else {
      speedValue = data;
    }
    return speedValue;
  };

  downloadLabel = () => {
    const dataIncludedLink = 'https://www.verizon.com/support/important-plan-information/';
    const networkManagementLink = 'https://www.verizon.com/about/our-company/network-management/';
    const privacyLink = 'https://www.verizon.com/about/privacy/';
    const customerSupportLink = 'https://www.verizon.com/support/contact-us/';
    const date = new Date();

    const sheetData = [];
    this.props.updatedJsonWithTax.broadbandFacts.broadbandLabel &&
      this.props.updatedJsonWithTax.broadbandFacts.broadbandLabel.map((item) => {
        const discountsBundleLink = this.getDiscountsAndBundles(item);
        sheetData.push({
          'PROVIDER NAME': item.provider?.providerName || 'none',
          'LABEL PLAN NAME': item.provider?.planName || 'none',
          TYPE: item.provider?.type || 'none',
          'MONTHLY PRICE': item.monthlyPrice?.headerVal || 'none',
          'INTRODUCTORY PRICE': item.monthlyPrice?.data[0]?.label || 'none',
          'INTRODUCTORY PRICE DETAILS': item.monthlyPrice?.data[0]?.value || 'N/A',
          'MONTHLY PRICE CONTRACT': item.monthlyPrice?.data[1]?.label || 'none',
          'MONTHLY PRICE CONTRACT DURATION': item.monthlyPrice?.data[1]?.value || 'N/A',
          'PROVIDER MONTHLY FEES': this.getTaxAndFeeDetails(item.additionalCharges?.data, 'provider monthly') || 'none',
          'ONE-TIME FEES AT THE TIME OF PURCHASE': this.getTaxAndFeeDetails(item.additionalCharges?.data, 'One-time Fees') || 'none',
          'EARLY TERMINATION FEE': this.getTaxAndFeeDetails(item.additionalCharges?.data, 'early termination fee') || 'none',
          'GOVERNMENT TAXES': this.getTaxAndFeeDetails(item.additionalCharges?.data, 'government taxes') || 'none',
          'DISCOUNTS & BUNDLES': { t: 's', v: discountsBundleLink, l: { Target: discountsBundleLink, Tooltip: discountsBundleLink } },
          'SPEED - DOWNLOAD': this.getSpeedProvided(item.speedsProvided?.data[0]?.value) || 'none',
          'SPEED - UPLOAD': this.getSpeedProvided(item.speedsProvided?.data[1]?.value) || 'none',
          'SPEED - LATENCY': this.getSpeedProvided(item.speedsProvided?.data[2]?.value) || 'none',
          'DATA INCLUDED WITH MONTHLY PRICE': item.dataIncluded?.headerVal || 'none',
          'DATA INCLUDED LINK': { t: 's', v: dataIncludedLink, l: { Target: dataIncludedLink, Tooltip: dataIncludedLink } },
          'CHARGES FOR ADDITIONAL DATA USAGE': item.dataIncluded?.data[0]?.value || 'none',
          'NETWORK MANAGEMENT LINK': { t: 's', v: networkManagementLink, l: { Target: networkManagementLink, Tooltip: networkManagementLink } },
          'PRIVACY LINK': { t: 's', v: privacyLink, l: { Target: privacyLink, Tooltip: privacyLink } },
          'CUSTOMER SUPPORT': {
            t: 's',
            v: `${customerSupportLink} \n800-922-0204`,
            l: { Target: customerSupportLink, Tooltip: customerSupportLink },
          },
          'UNIQUE PLAN IDENTIFIER': item.footnote || 'none',
          ...( isFCCInternalPage() && {'DATETIME': (this.props?.selectedDate && date?.toLocaleTimeString()) ? `${this.props?.selectedDate} ${date?.toLocaleTimeString()}` : '',
          'LOCATION': getSelectedAddress()?.entireStreetAddress || ''}),
        });
      });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(sheetData);
    ws['!cols'] = [{ wch: 10 }];
    XLSX.utils.book_append_sheet(wb, ws, 'Mysheet');

    XLSX.writeFile(wb, 'Broadband facts.xlsx');
  };

  EditAddress = () => {
    if (isHomeInternetBroadBandFlow()) {
      const { site } = getFCCFlowName();
      if (site === fccConstantValues?.NationalRetailerFlow) {
        window.location.href = `${apiUrls().fccReviewUrlNationRetailer}?editfromOrdering=Y`;
      } else {
        window.location.href = `${apiUrls().fccReviewUrl}?editfromOrdering=Y`;
      }
    } else {
      const { continueButtonStatus } = this.props;
      continueButtonStatus(false);
      this.setState({ showModel: true });
    }
  };

  onChangeDate = (e, type) => {
    let { value } = e.target;
    this.setState({disableSaveButon : true});
      if (value) {
        const x = value;
        const str = x.replace(/\//g, '').toString();
        const DateFormat = `${str.slice(0, 2)}/${str.slice(2, 4)}/${str.slice(4, 8)}`;
        value = DateFormat;
        this.setState({disableSaveButon : !isValidLabelsDate(DateFormat)});
      }     
    this.setState({
      updatedDate: value,
    });
    if(type === 'save'){
      store.dispatch({ type: 'SET_SELECTED_DATE', data: this.state.updatedDate});
      this.closeDateModal();
    }
  }

  EditDate = () => {
    this.setState({showDateModel: true})
  };  

  ReviewLabelsFor55PlusPlans = () => {
    document.cookie = "category=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = `${xss('category')}=55+`
    window.location.href = `${apiUrls().redirectAddressSearch}`;
  };

  ReviewLabelsForOtherPlans = () => {
    window.location.href = `${apiUrls().fccReviewUrl}`;
  };

  getAddressValue = () => {
    let value = '';
    if (checkStandAloneFccPage()) {
      value = getSelectedAddress()?.entireStreetAddress;
    } else if (isHomeInternetBroadBandFlow()) {
      const LQResponseData = JSON.parse(getSession('LQResponse'));
      const addressDetails = LQResponseData?.output;
      const { addressLine1, addressLine2, city, state, zipCode } = addressDetails || '';
      let addressLine = addressLine1 ? `${addressLine1},` : '';
      if (addressLine2) {
        addressLine += `${addressLine2},`;
      }
      value = `${addressLine} ${city}, ${state}, ${zipCode}`;
    }
    return `<div style="margin-top:-12px">${value}</div>`;
  };

  addingMVALinksToStructure = (sortedPlanIds, list) => {
    if (list && list.length > 0) {
      const linkIds = ['privacy', 'networkManagement', 'customerSupport', 'dataMonthly', 'acp', 'discountsBundles', 'footer'];
      if (sortedPlanIds && sortedPlanIds.length > 0) {
        sortedPlanIds.map((planId, pIndex) => {
          linkIds.forEach((id, index) => {
            const dom = document.getElementById(`${id}-${planId}`);
            const element = list?.filter((item) => String(item.planCode) === String(planId));
            let selElement = element?.[0]?.sections?.filter((item) => item.id === id)?.[0]?.description;
            if (id === 'dataMonthly') {
              selElement = element?.[0]?.sections?.filter((item) => item.id === id)?.[0]?.header;
            }
            if (id === 'footer') {
              selElement = element?.[0]?.footer;
            }

            if (dom) {
              if (isMVA()) {
                const url = selElement?.match(/href="([^"]*)/)?.[1];
                dom.onclick = () => this.onClickingLink(url);
                // eslint-disable-next-line no-script-url
                dom.setAttribute('href', 'javascript:void(0)');
              }
              if (id === 'customerSupport') {
                dom.style.color = '#000';
                dom.style.textDecoration = 'none';
              }
              if (index === linkIds.length - 1 && pIndex === sortedPlanIds.length - 1) {
                this.setState({ fccJsonvalue: true });
              }
            }
          });
        });
      }
    }
  };

  renderingFactSections = (args) => {
    const { location } = this.props;
    const renderChildren = [];
    if (args && args?.broadbandFacts && args?.broadbandFacts?.header?.data?.title) {
      renderChildren.push(
        <Row className="marginBottom20">
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
            <TitleLockup surface="light" data={{ title: args?.broadbandFacts?.header?.data?.title }} />
          </Col>
        </Row>,
      );
    }
    if (args && args?.broadbandFacts && getCookie('site') === 'InternalFlow' && location?.pathname?.includes('broadBandFacts')) {
      renderChildren.push(
        <Row className="marginBottom20">
          <Col>
            <Button role="link" onClick={() => this.downloadLabel()}>
              Download broadband labels
            </Button>
          </Col>
        </Row>,
      );
    }
    if (args && args?.broadbandFacts && args?.broadbandFacts?.header?.data?.subtitle) {
      renderChildren.push(
        <Row className="marginBottom20">
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 4 }}>
            <TitleLockup surface="light" data={{ subtitle: args?.broadbandFacts?.header?.data?.subtitle }} />
          </Col>
        </Row>,
      );
    }
    if (args && args?.broadbandFacts && args?.broadbandFacts?.broadbandLabel && args?.broadbandFacts?.broadbandLabel?.length > 0) {
      const data = isMobile() ? (
        <CarouselComponent data={args?.broadbandFacts?.broadbandLabel} />
      ) : (
        <Row>
          {args &&
            args?.broadbandFacts &&
            args?.broadbandFacts?.broadbandLabel &&
            args?.broadbandFacts?.broadbandLabel?.length > 0 &&
            args?.broadbandFacts?.broadbandLabel.map((item) => (
              <Col colSizes={{ mobile: 4, tablet: 6, desktop: 4 }}>
                <div className="marginBottom20">
                  <BroadbandLabel {...item} />
                </div>
              </Col>
            ))}
        </Row>
      );
      renderChildren.push(data);
    }
    return renderChildren;
  };

  closeModel = () => {
    this.setState({ showModel: false });
    this.setState({
      streetAddress: this.getLocalStorageParsedItem('SELECTED_ADDRESS')?.entireStreetAddress || '',
    });
  };

  closeDateModal = () => {
    this.setState({ showDateModel: false });
  }

  render() {
    let plan55Filter = getCookie('category');
    plan55Filter = plan55Filter.indexOf('55+') > -1;
    const addressLine = showAddress() ? this.getAddressValue() : null;
    if (
      (this.props?.updatedJsonWithTax && this.props.fccContentValue && !this.state.fccJsonvalue && isHomeInternetBroadBandFlow()) ||
      !showSurcharges()
    ) {
      const sortedPlanIds = Object.keys(this.props?.planDetails || {}).filter((planId) => this.props.planDetails[planId]);
      this.addingMVALinksToStructure(sortedPlanIds, this.props.fccContentValue?.plans);
    } else if (
      this.props?.updatedJsonWithTax &&
      this.props.fccLabel?.detailList &&
      !this.state.fccJsonvalue &&
      checkStandAloneFccPage() &&
      showSurcharges()
    ) {
      const planIdArray = [];
      this.props?.fccLabel?.detailList?.plans.map((item) => {
        planIdArray.push(item.planCode);
      });
      this.addingMVALinksToStructure(planIdArray, this.props?.fccLabel?.detailList?.plans);
    }

    return (
      <div className="pad15 noSidePad">
        <FWAContainer>
          <Row className="marginTop15 marginBottom10 justfy-end">
            <Col>
              <div style={{ marginBottom: '15px' }}>
                <LanguageLink onClickFunc={this.onClickOnLanguageTranslation} />
              </div>
            </Col>
          </Row>
          <Row>
            <Notification renderIf={this.props?.showError} title={this.props.notifyMessage} type="warning" />
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              {addressLine && (
                <div
                  className="marginTop15"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: isDesktop() ? '40%' : '100%',
                    paddingBottom: '20px',
                    paddingRight: '20px',
                  }}
                >
                  <div>
                    <TitleLockup
                      data={{
                        title: {
                          children: parse('<span style="font-size:16px;margin-bottom:0"> Your address:</span  >' || ''),
                          primitive: 'h3',
                        },
                        subtitle: {
                          children: parse(addressLine || ''),
                          size: 'bodyLarge',
                        },
                      }}
                    />
                  </div>
                  <TextLink
                    id="EditAddress"
                    ariaLabel="EditAddress"
                    onClick={() => this.EditAddress()}
                    onKeyPress={() => this.EditAddress()}
                    analyticstrack="EditAddress"
                    tabIndex="0"
                    type="standAlone"
                    role="link"
                    data-track='{"type": "link",  name: "edit address -plans"}'
                  >
                    Edit
                  </TextLink>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              {isFCCInternalPage() && this.props?.selectedDate && (
                <div
                  className="marginTop15"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: isDesktop() ? '40%' : '100%',
                    paddingBottom: '20px',
                    paddingRight: '20px',
                  }}
                >
                  <div>
                    <TitleLockup
                      data={{
                        title: {
                          children: parse('<span style="font-size:16px;margin-bottom:0"> Date:</span  >' || ''),
                          primitive: 'h3',
                        },
                        subtitle: {
                          children: parse(this.props?.selectedDate || ''),
                          size: 'bodyLarge',
                        },
                      }}
                    />
                  </div>
                  <TextLink
                    id="EditDate"
                    ariaLabel="EditDate"
                    onClick={() => this.EditDate()}
                    onKeyPress={() => this.EditDate()}
                    analyticstrack="EditDate"
                    tabIndex="0"
                    type="standAlone"
                    role="link"
                    data-track='{"type": "link",  name: "edit date"}'
                  >
                    Edit
                  </TextLink>
                </div>
              )}
            </Col>
          </Row>

          <Row>
            <Col>
            {isFCCInternalPage() && getCookie('category') === 'Unlimited' && isMobile() && (
                <TextLinkCaret
                  className="reviewLabels"
                  id="ReviewLabelsFor55PlusPlans"
                  ariaLabel="ReviewLabelsFor55PlusPlans"
                  onClick={() => this.ReviewLabelsFor55PlusPlans()}
                  onKeyPress={() => this.ReviewLabelsFor55PlusPlans()}
                  analyticstrack="ReviewLabelsFor55PlusPlans"
                  tabIndex="0"
                  type="standAlone"
                  role="link"
                  data-track="{type: 'link',  name: 'Review labels for 55Plus plans'}"
                >
                  Review labels for other plans
                </TextLinkCaret>
              )}
              {plan55Filter && isMobile() && !isFCCInternalPage() && (
                <TextLinkCaret
                  className="reviewLabels"
                  id="ReviewLabelsForOtherPlans"
                  ariaLabel="ReviewLabelsForOtherPlans"
                  onClick={() => this.ReviewLabelsForOtherPlans()}
                  onKeyPress={() => this.ReviewLabelsForOtherPlans()}
                  analyticstrack="ReviewLabelsForOtherPlans"
                  tabIndex="0"
                  type="standAlone"
                  role="link"
                  data-track="{type: 'link',  name: 'Review labels for other plans mobile'}"
                >
                  Review labels for other plans
                </TextLinkCaret>
              )}
            </Col>
          </Row>
          {this.renderingFactSections(this.props?.updatedJsonWithTax)}
          <Row>
            <Col>
              {plan55Filter && !isMobile() && !isFCCInternalPage() && (
                <TextLinkCaret
                  className="reviewLabels"
                  id="ReviewLabelsForOtherPlans"
                  ariaLabel="ReviewLabelsForOtherPlans"
                  onClick={() => this.ReviewLabelsForOtherPlans()}
                  onKeyPress={() => this.ReviewLabelsForOtherPlans()}
                  analyticstrack="ReviewLabelsForOtherPlans"
                  tabIndex="0"
                  type="standAlone"
                  role="link"
                  data-track='{"type": "link",  name: "Review labels for other plans"}'
                >
                  Review labels for other plans
                </TextLinkCaret>
              )}
              {isFCCInternalPage() && getCookie('category') === 'Unlimited' && !isMobile() && (
                <TextLinkCaret
                  className="reviewLabels"
                  id="ReviewLabelsFor55PlusPlans"
                  ariaLabel="ReviewLabelsFor55PlusPlans"
                  onClick={() => this.ReviewLabelsFor55PlusPlans()}
                  onKeyPress={() => this.ReviewLabelsFor55PlusPlans()}
                  analyticstrack="ReviewLabelsFor55PlusPlans"
                  tabIndex="0"
                  type="standAlone"
                  role="link"
                  data-track='{"type": "link",  name: "Review labels for 55Plus plans"}'
                >
                  Review labels for other plans
                </TextLinkCaret>
              )}
            </Col>
          </Row>

          <>
          {this.state.showDateModel && (
              <CommonModal
                modalTitle="Edit date"
                id="dateEditModel"
                ariaLabel="Date modal "
                closeButtonId="dateEditCloseButton"
                onOpenedChange={() => {
                  const closeButton = document.getElementById('dateEditCloseButton');
                  if (closeButton) {
                    closeButton.onClick = this.closeDateModal();
                  }
                }}
                modalBody={
                  <>
                  <ReqInput
                    id="LabelsDate"
                    type="date"
                    dateFormat="mmddyyyy"
                    isPiiMask
                    onChange={(e) => this.onChangeDate(e)}
                    error = {false}
                    errorText=''
                    required
                    label='Date'
                    defaultValue={this.props?.selectedDate}
                />
                <Row className="width100">
                  <Col className="margin4">
                    <Button
                      onClick={(e) => {
                        this.onChangeDate(e, 'save')
                      }}
                      disabled={this.state.disableSaveButon}
                    >
                      Save
                    </Button>
                    </Col>
                    <Col className="margin4">
                    <Button
                      secondary
                      onClick={() => {
                        this.closeDateModal();
                      }}
                    >
                        Close
                    </Button>
                    </Col>
            </Row>
            </>
                }
                opened={this.state.showDateModel}
                
              />
            )}
            {this.state.showModel && (
              <CommonModal
                modalTitle="Enter your Address"
                id="addressSearchModel"
                ariaLabel="Address modal "
                closeButtonId="addressSearchCloseButton"
                onOpenedChange={() => {
                  const closeButton = document.getElementById('addressSearchCloseButton');
                  if (closeButton) {
                    closeButton.onClick = this.closeModel();
                  }
                }}
                opened={this.state.showModel}
                analyticstrack="FWA-AddressSearch Model"
                modalBody={
                  <>
                    <AddressSearchComponent
                      {...this.props}
                      onChangeStreetAddress={this.onChangeStreetAddress}
                      open="popup"
                      closebuttonFn={this.closeModel}
                      streetAddress={this.state.streetAddress}
                      apiIntegration={this.apiIntegration}
                    />
                  </>
                }
              />
            )}
          </>
        </FWAContainer>
      </div>
    );
  }
}